import PageHeader from "../components/PageHeader";

const SECTIONS = [
  {
    h: "1. Who we are",
    p: 'DN Flooring, Interior Design ("DN Flooring," "we," "our," or "us") is a Florida-based remodeling company. This Privacy Policy explains how we collect, use, and protect information when you visit our website or request services from us.',
  },
  {
    h: "2. Information we collect",
    p: "When you submit a quote request, contact form, or other inquiry, we may collect: your name, phone number, email address, property address, project details, and any other information you choose to share. We also automatically collect basic technical data — IP address, browser type, device, and pages visited — through standard server logs and privacy-respecting analytics.",
  },
  {
    h: "3. How we use your information",
    p: "We use your information only to: (a) respond to your quote or contact request, (b) schedule and complete the work you've asked us to do, (c) send transactional confirmations or follow-ups, and (d) improve and secure our website. We do not sell, rent, or trade your personal information.",
  },
  {
    h: "4. Email & communications",
    p: "Quote-form submissions are delivered to our team via Resend, a transactional-email service. By submitting the form you consent to us contacting you via the phone number or email address you provided. You may opt out of non-essential communications at any time by replying \"STOP\" or emailing us.",
  },
  {
    h: "5. Sharing with third parties",
    p: "We share information only with: (a) our internal team needed to fulfill your request, (b) reputable service providers (e.g., Resend for email, our hosting provider) bound by confidentiality, and (c) authorities when required by law. We never sell your data.",
  },
  {
    h: "6. Cookies",
    p: "Our site uses minimal cookies — essential cookies for the site to function, and optional analytics cookies to understand traffic. You can disable cookies in your browser; some site features may not work without them.",
  },
  {
    h: "7. Data retention & security",
    p: "We retain quote and contact submissions for as long as needed to provide service and meet legal/tax obligations. Data is stored on secured infrastructure with industry-standard protections. While no system is 100% secure, we take reasonable steps to protect the information you share.",
  },
  {
    h: "8. Your rights",
    p: "You may request a copy of, correction to, or deletion of personal information we hold about you by emailing Dn1floor@gmail.com. We'll respond within a reasonable time frame in accordance with applicable Florida and U.S. privacy law.",
  },
  {
    h: "9. Children's privacy",
    p: "Our site is not directed to children under 13. We do not knowingly collect personal information from children. If you believe we've received such information, please contact us and we will delete it.",
  },
  {
    h: "10. Changes to this policy",
    p: "We may update this Privacy Policy from time to time. The latest version will always be available on this page with the date below.",
  },
  {
    h: "11. Contact us",
    p: "Questions about this Privacy Policy? Email Dn1floor@gmail.com or call (941) 626-5241.",
  },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function PrivacyPage() {
  return (
    <main data-testid="privacy-page">
      <PageHeader
        eyebrow="Legal"
        title="Privacy Policy."
        accent="Your data, respected."
      />

      <section className="pb-20 lg:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
            {/* TOC */}
            <aside className="lg:col-span-4 lg:sticky lg:top-28 h-fit">
              <div className="rounded-lg border border-white/5 bg-[#2a3744] p-6">
                <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-4">
                  Contents
                </div>
                <nav>
                  <ul className="space-y-2.5">
                    {SECTIONS.map((s) => (
                      <li key={s.h}>
                        <a
                          href={`#${slug(s.h)}`}
                          className="text-[13px] text-slate-400 hover:text-white transition-colors"
                        >
                          {s.h}
                        </a>
                      </li>
                    ))}
                  </ul>
                </nav>
                <div className="mt-6 pt-5 border-t border-white/10 text-[11px] uppercase tracking-[0.22em] text-slate-500">
                  Last updated: April 2026
                </div>
              </div>
            </aside>

            {/* Body */}
            <div className="lg:col-span-8 space-y-10">
              {SECTIONS.map((s) => (
                <div key={s.h} id={slug(s.h)} className="scroll-mt-28">
                  <h2 className="font-serif text-xl sm:text-2xl text-white tracking-tight leading-tight">
                    {s.h}
                  </h2>
                  <p className="mt-3 text-[15px] text-slate-300 leading-[1.75]">
                    {s.p}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
